// extracted by mini-css-extract-plugin
export default {"brandListArea":"brandList_brandListArea__Kuv6+","toggleArea":"brandList_toggleArea__KC2nW","stretch":"brandList_stretch__iCJC1","imgArea":"brandList_imgArea__sBjs7"};